export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9767.2050ca44.jpg";